// extracted by mini-css-extract-plugin
export var h2_semi_bold_serp = "h_F";
export var noBoxShadow = "h_H";
export var serpCard = "h_C";
export var serpCardContainer = "h_B";
export var serpDescription = "h_G";
export var serpLink = "h_D";